import { makeStyles, Box } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: `${theme.spacing(2.8)}px ${theme.spacing(2)}px`,
    minHeight: 135,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
}))

export const CardBox = ({ children }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      {children}
    </Box>
  )
}
